








import AulaAlert from '../AulaAlert.vue';
import { defineComponent, onMounted } from 'vue';
import { useLoginAnnouncement } from '../../composables/useLoginAnnouncement';

export default defineComponent({
  name: 'LoginAnnouncement',
  components: {
    AulaAlert,
  },
  setup() {
    const { message, fetch } = useLoginAnnouncement();

    onMounted(() => {
      fetch();
    });

    return {
      message,
    };
  },
});
